import { ReactNode, useState } from 'react';
import { Image } from '@belong/ui';
import clsx from 'clsx';
import { type BlogPostAuthorData } from 'src/features/blog/types';
import css from './about-author.module.css';

type Variant = 'default' | 'large' | 'withHover';

const variantToClassName: Record<Variant, string> = {
  default: css.imageContainer,
  large: css.largeImageContainer,
  withHover: css.imageContainer,
};

type AboutAuthorProps = {
  author?: BlogPostAuthorData;
  firstLine: ReactNode;
  secondLine: ReactNode;
  showImg?: boolean;
  variant?: Variant;
};

// Reason for this is that the prismic images are terrible for some authors
// and we don't want to change the images on the CMS until this change is released.
const overwriteSrc = {
  Tyler: '/blog/author_images/6-d7e65b53b808170b',
  Melanie: '/blog/author_images/mel.jpg',
  Adam: '/blog/author_images/adam.jpg',
  'Ale, Owen & Tyler': '/blog/author_images/profile_founders.jpg',
};

export function AboutAuthor({
  author,
  firstLine,
  secondLine,
  showImg = false,
  variant = 'default',
}: AboutAuthorProps): JSX.Element {
  const [hover, setHover] = useState(false);

  const renderImg = showImg && author?.profile_image_url?.url;

  const enableHover = variant === 'withHover' && hover;

  return (
    <div className="flex items-center" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {renderImg && (
        <div
          className={clsx(
            variantToClassName[variant],
            'flex-none border-2 border-solid rounded-full bg-green overflow-hidden',
            enableHover && 'border-dark-navy'
          )}
        >
          {overwriteSrc[author.first_name] ? (
            <Image src={overwriteSrc[author.first_name]} className="object-contain" alt="" />
          ) : (
            <Image src={author.profile_image_url.url} className="object-contain" alt="" />
          )}
        </div>
      )}
      <div className={clsx(enableHover && 'text-dark-navy')}>
        {firstLine}
        {secondLine}
      </div>
    </div>
  );
}
